import translate from "src/functions/translate";

function optionsFocus(lang: string) {
  return [
    { title: translate(`any`, lang), value: `any` },
    { title: translate(`breathing`, lang), value: `breathing` },
    { title: translate(`concentration`, lang), value: `concentration` },
    {
      title: translate(`development`, lang),
      value: `development`,
    },
    { title: translate(`enlightenment`, lang), value: `enlightenment` },
    { title: translate(`flexibility`, lang), value: `flexibility` },
    { title: translate(`flow`, lang), value: `flow` },
    { title: translate(`health`, lang), value: `health` },
    { title: translate(`knowledge`, lang), value: `knowledge` },
    { title: translate(`meditation`, lang), value: `meditation` },
    { title: translate(`mobility`, lang), value: `mobility` },
    { title: translate(`morality`, lang), value: `morality` },
    { title: translate(`postures`, lang), value: `postures` },
    { title: translate(`realization`, lang), value: `realization` },
    { title: translate(`regeneration`, lang), value: `regeneration` },
    { title: translate(`relaxation`, lang), value: `relaxation` },
    { title: translate(`senses`, lang), value: `senses` },
    { title: translate(`slowdown`, lang), value: `slowdown` },
    {
      title: translate(`stamina in postures`, lang),
      value: `stamina_in_postures`,
    },
    { title: translate(`strengthening`, lang), value: `strengthening` },
  ];
}

export default optionsFocus;
